import { Control } from 'react-hook-form';

import {
  AccountTypeFormGroup,
  ConnectedThemeSetFormGroup,
  ReferenceIdFormGroup,
} from 'dashboard/components/CreateInquiry/CreateInquiryFormGroups';
import { AccountTypesFilterOption } from 'dashboard/models/account-type';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

export type CreateInquiryGeneralInfoSimulateProps = {
  accountTypeBasics: AccountTypesFilterOption[];
  submitting: boolean;
  control: Control;
};

function CreateInquiryGeneralInfoSimulate({
  accountTypeBasics,
  submitting,
  control,
}: CreateInquiryGeneralInfoSimulateProps) {
  return (
    <>
      <Paragraph>Create a new Inquiry for preview with specified prefilled attributes</Paragraph>
      <Spacer height={2} />

      <ReferenceIdFormGroup control={control} submitting={submitting} />

      {accountTypeBasics.length > 1 && (
        <AccountTypeFormGroup
          accountTypeFilterOptions={accountTypeBasics}
          control={control}
          submitting={submitting}
        />
      )}

      <ConnectedThemeSetFormGroup control={control} submitting={submitting} />
    </>
  );
}

export default CreateInquiryGeneralInfoSimulate;
